export const colors = {
  brokenWhite: "#fcf9f6",
  darkBlue: "#106d95",
  lightBlue: "#39a7d5",
  extreLightBlue: "#ccdde2",
};

export const breakpoints = ["48em", "60em", "64em"];
